import React, { Component } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import RowSlider from '../../components/RowSlider';

import {
  GRAPH_ELEMENTS,
  CIRCLE_FAMILY,
  BAR_FAMILY,
  LINE_FAMILY,
  SPECIAL_FAMILY
} from '../../../modules/graphic-elements';

const HORIZONTAL_PADDING = 15;
const NAV_BAR_HEIGHT = 56;
const HEADER_HEIGHT = 53; // When it is all in the same line
const TITLE_HEIGHT = 49;
const ALERT_HEIGHT = 66;
const LEFT_VERTICAL_HEIGHT = NAV_BAR_HEIGHT + HEADER_HEIGHT + TITLE_HEIGHT;
const RIGHT_VERTICAL_HEIGHT = LEFT_VERTICAL_HEIGHT + ALERT_HEIGHT;

class GraphicsSelectionContainer extends Component {
  state = {
    height: window.innerHeight,
    width: window.innerWidth,
    preview: ''
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ height: window.innerHeight, width: window.innerWidth });
  };

  changePreview = newPreview => {
    this.setState({ preview: newPreview });
  };

  returnPreview = preview => {
    const { width, height } = this.state;
    const elementWithProps = React.cloneElement(GRAPH_ELEMENTS[preview], {
      width: width / 2 - HORIZONTAL_PADDING * 2,
      height: height - RIGHT_VERTICAL_HEIGHT
    });

    return elementWithProps;
  };

  render() {
    const { preview } = this.state;
    const { handleGraphicType } = this.props;
    const leftColHeight = `calc(100vh - ${LEFT_VERTICAL_HEIGHT}px)`;
    const rightColHeight = `calc(100vh - ${RIGHT_VERTICAL_HEIGHT}px)`;
    return (
      <Row>
        <Col xs={12} md={6} style={{ overflowY: 'scroll', height: leftColHeight }}>
          <RowSlider
            familyProperties={CIRCLE_FAMILY}
            onGraphHover={this.changePreview}
            onGraphClick={handleGraphicType}
          />
          <RowSlider
            familyProperties={BAR_FAMILY}
            onGraphHover={this.changePreview}
            onGraphClick={handleGraphicType}
          />
          <RowSlider
            familyProperties={LINE_FAMILY}
            onGraphHover={this.changePreview}
            onGraphClick={handleGraphicType}
          />
          <RowSlider
            familyProperties={SPECIAL_FAMILY}
            onGraphHover={this.changePreview}
            onGraphClick={handleGraphicType}
          />
        </Col>
        <Col xs={12} md={6} style={{ height: rightColHeight }}>
          <Alert variant="info">
            {isEmpty(preview)
              ? 'Please select a Graphic'
              : `Previewing ${GRAPH_ELEMENTS.properties[preview].humanValue}`}
          </Alert>
          {!isEmpty(preview) && this.returnPreview(preview)}
        </Col>
      </Row>
    );
  }
}
GraphicsSelectionContainer.propTypes = {
  handleGraphicType: PropTypes.func.isRequired
};

export default GraphicsSelectionContainer;
